export enum Constants {
    LOAD_FONTS,
    LOAD_FONTS_FINISH
}
